import { useEffect } from 'react';

interface SEOSchemaProps {
  schema: Record<string, unknown> | Record<string, unknown>[];
  id?: string;
}

export default function SEOSchema({ schema, id = 'schema-jsonld' }: SEOSchemaProps) {
  useEffect(() => {
    const existingScript = document.getElementById(id);
    if (existingScript) {
      existingScript.remove();
    }
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = id;
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      const s = document.getElementById(id);
      if (s) s.remove();
    };
  }, [schema, id]);

  return null;
}
